/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ZonePublic { 
    Name: string;
    Id: string;
    AreaId: string;
    Width: number;
    Height: number;
    X: number;
    Y: number;
    MaxPeople: number | null;
    MaxSpeed: number | null;
    CreatedBy: string;
    CreationDate: string;
    LastEdit: string | null;
    LastEditBy: string | null;
}

